module.exports = __webpack_public_path__ + "static/media/transparencia.01ff201c.svg";